import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(
    'pk_test_51JQNUAJClwFJyX55hlOi29eW5mAmacl4qzM1JPL5xPo5ggd7ymnbMjUnNNqo0cZ5T5SnpH5nBmq4saguS3WiBreU00rzrmM28X'
);
